<template>
    <div>
        <NavbarOne/>

        <div class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70" :style="{backgroundImage:'url(' + bg + ')'}">
            <div class="text-center w-full">
                <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">My Account</h2>
                <ul class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4">
                    <li><router-link to="/index-v2">Home</router-link></li>
                    <li>/</li>
                    <li class="text-primary">Account</li>
                </ul>
            </div>
        </div>

        <div class="s-py-100" data-aos="fade-up">
            <div class="container-fluid">
                <div class="max-w-[1720px] mx-auto flex items-start gap-8 md:gap-12 2xl:gap-24 flex-col md:flex-row my-profile-navtab">
                    <div class="w-full md:w-[200px] lg:w-[300px] flex-none">
                        <ProfileTab/>
                    </div>
                    <div class="w-full md:w-auto md:flex-1 overflow-auto">
                        <div class="w-full max-w-[951px] bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-8 lg:p-[50px]">
                            <div>
                                <h3 class="font-semibold leading-none">{{ profile.name || 'Client Account' }}</h3>
                                <span class="leading-none mt-3">{{ profile.designation || 'Customer Account' }}</span>
                            </div>
                            <div class="mt-5 sm:mt-8 md:mt-10 grid gap-4 sm:gap-6">
                                <div class="flex items-center gap-2">
                                    <i class="fa-solid fa-phone text-[#BB976D]"></i>
                                    <span class="leading-none font-medium text-base sm:text-lg">{{ profile.phone || 'No phone added yet' }}</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <i class="fa-solid fa-envelope text-[#BB976D]"></i>
                                    <span class="leading-none font-medium text-base sm:text-lg">{{ profile.email }}</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <i class="fa-solid fa-location-dot text-[#BB976D]"></i>
                                    <span class="leading-none font-medium text-base sm:text-lg">{{ fullAddress || 'No address added yet' }}</span>
                                </div>
                            </div>
                        </div>
                        <form class="w-full max-w-[951px] bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-8 lg:p-[50px] mt-8" @submit.prevent="saveChanges">
                            <div class="flex items-start flex-col lg:flex-row gap-5 sm:gap-6">
                                <div class="grid gap-5 sm:gap-6 w-full lg:w-1/2">
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Full Name</label>
                                        <input v-model="form.name" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your full name">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Designation</label>
                                        <input v-model="form.designation" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your designation">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Phone No.</label>
                                        <input v-model="form.phone" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Type your phone number">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Mail</label>
                                        <input v-model="form.email" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="email" placeholder="Enter your email address">
                                    </div>
                                </div>
                                <div class="grid gap-5 sm:gap-6 w-full lg:w-1/2">
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Location</label>
                                        <input v-model="form.address_line" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your location">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">City</label>
                                        <input v-model="form.city" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your city">
                                    </div>
                                    <div>
                                        <label class="text-base md:text-lg text-title dark:text-white leading-none mb-2 sm:mb-3 block">Country</label>
                                        <input v-model="form.country" class="w-full h-12 md:h-14 bg-white dark:bg-dark-secondary border border-[#E3E5E6] text-title dark:text-white focus:border-primary p-4 outline-none duration-300" type="text" placeholder="Enter your country">
                                    </div>
                                </div>
                            </div>
                            <p v-if="message" class="mt-6 text-sm text-[#31A051]">{{ message }}</p>
                            <p v-if="generalError" class="mt-6 text-sm text-[#E13939]">{{ generalError }}</p>
                            <div class="mt-5 sm:mt-8 md:mt-12 flex flex-wrap gap-4">
                                <button class="btn btn-solid" data-text="Save Change" :disabled="saving">
                                    <span>{{ saving ? 'Saving...' : 'Save Change' }}</span>
                                </button>
                                <router-link to="/edit-account" class="btn btn-outline" data-text="Advanced Edit">
                                    <span>Advanced Edit</span>
                                </router-link>
                            </div>
                        </form>
                        <div class="bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-8 lg:p-[50px] order-history-table mt-8">
                            <ul class="order-history">
                                <li class="title flex items-center justify-between gap-5 pb-[10px] sm:pb-5 border-b border-bdr-clr dark:border-bdr-clr-drk">
                                    <span class="cart-product-title text-lg md:text-xl font-semibold leading-none text-title dark:text-white block w-[270px] sm:w-[310px] xl:w-[330px]">Product</span>
                                    <span class="text-lg md:text-xl font-semibold leading-none text-title dark:text-white w-[60px]">Price</span>
                                    <span class="text-lg md:text-xl font-semibold leading-none text-title dark:text-white w-[100px]">Status</span>
                                </li>
                                <li v-for="(item, index) in recentItems" :key="index" class="flex items-center justify-between gap-5 py-[15px] sm:py-[15px] border-b border-bdr-clr dark:border-bdr-clr-drk">
                                    <div class="flex items-center gap-3 md:gap-4 lg:gap-6 ordered-product w-[270px] sm:w-[310px] xl:w-[330px]">
                                        <div class="w-16 sm:w-[90px] flex-none">
                                            <img :src="item.image || fallbackImage" alt="product">
                                        </div>
                                        <div class="flex-1">
                                            <span class="text-[15px] font-medium leading-none">{{ item.tag }}</span>
                                            <h5 class="font-semibold leading-none mt-2 md:mt-4"><router-link :to="item.productUrl">{{ item.name }}</router-link></h5>
                                        </div>
                                    </div>

                                    <span class="text-base md:text-lg leading-none text-title dark:text-white font-semibold text-left w-[60px]">${{ item.price }}</span>

                                    <div class="w-[120px]">
                                        <span :class="statusBadgeClass(item.status)" class="py-[7px] px-[10px] font-semibold leading-none text-white text-sm rounded inline-flex">
                                            {{ item.status_label || item.status }}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                            <p v-if="!loading && !recentItems.length" class="mt-8 text-base md:text-lg">No orders yet.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <FooterOne/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
    import { computed, onMounted, reactive, ref, watch } from 'vue';
    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import ProfileTab from '@/components/profile-tab.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import bg from '@/assets/img/shortcode/breadcumb.jpg'
    import fallbackImage from '@/assets/img/gallery/cart/cart-01.jpg'
    import Aos from 'aos';
    import { apiRequest } from '@/lib/client-api';
    import { useClientSession } from '@/composables/use-client-session';

    const session = useClientSession();
    const profile = computed(() => session.state.user || {});
    const fullAddress = computed(() => [profile.value.address_line, profile.value.city, profile.value.country].filter(Boolean).join(', '));
    const recentItems = ref([]);
    const loading = ref(true);
    const saving = ref(false);
    const generalError = ref('');
    const message = ref('');
    const form = reactive({
        name: '',
        email: '',
        phone: '',
        designation: '',
        address_line: '',
        city: '',
        country: '',
    });

    function statusBadgeClass(status) {
        switch (status) {
            case 'delivered':
                return 'bg-[#31A051]';
            case 'processing':
                return 'bg-[#2563EB]';
            case 'confirmed':
                return 'bg-[#7C3AED]';
            case 'ready':
                return 'bg-[#0F766E]';
            case 'cancelled':
                return 'bg-[#E13939]';
            default:
                return 'bg-[#EC991D]';
        }
    }

    function syncForm(user) {
        form.name = user?.name || '';
        form.email = user?.email || '';
        form.phone = user?.phone || '';
        form.designation = user?.designation || '';
        form.address_line = user?.address_line || '';
        form.city = user?.city || '';
        form.country = user?.country || '';
    }

    async function saveChanges() {
        generalError.value = '';
        message.value = '';
        saving.value = true;

        try {
            await session.updateProfile(form);
            message.value = 'Profile updated successfully.';
        } catch (error) {
            generalError.value = error.message;
        } finally {
            saving.value = false;
        }
    }

    async function loadRecentOrders() {
        loading.value = true;

        try {
            const response = await apiRequest('/orders', { token: session.token.value });
            recentItems.value = response.data.flatMap((order) =>
                order.items.map((item) => ({
                    ...item,
                    productUrl: item.product_id ? `/product-details/${item.product_id}` : '/product-details',
                }))
            ).slice(0, 5);
        } finally {
            loading.value = false;
        }
    }

    watch(() => session.state.user, (user) => {
        syncForm(user);
    }, { immediate: true });

    onMounted(async ()=>{
        Aos.init()
        await session.initializeSession();
        syncForm(session.state.user);
        await loadRecentOrders();
    })
</script>
